"use client";
import { useState, useEffect } from 'react';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDarkSection, setIsDarkSection] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const checkCurrentSection = () => {
    const scrollPosition = window.pageYOffset + window.innerHeight / 2;
    

    const darkSections = document.querySelectorAll('[data-dark-section="true"], .bg-black, .bg-gray-900, .bg-slate-900, [style*="background"]');
    
    let currentlyInDarkSection = false;
    
    darkSections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + window.pageYOffset;
      const sectionBottom = sectionTop + rect.height;

      if (scrollPosition >= sectionTop && scrollPosition <= sectionBottom) {

        const computedStyle = window.getComputedStyle(section as Element);
        const bgColor = computedStyle.backgroundColor;

        const isDark = (
          section.classList.contains('bg-black') ||
          section.classList.contains('bg-gray-900') ||
          section.classList.contains('bg-slate-900') ||
          section.hasAttribute('data-dark-section') ||
          bgColor.includes('rgb(32, 32, 32)') || 
          bgColor.includes('rgb(0, 0, 0)') ||  
          bgColor.includes('rgb(17, 24, 39)')   
        );
        
        if (isDark) {
          currentlyInDarkSection = true;
        }
      }
    });
    
    setIsDarkSection(currentlyInDarkSection);
  };

  useEffect(() => {
    const handleScroll = () => {
      toggleVisibility();
      checkCurrentSection();
    };

    window.addEventListener('scroll', handleScroll);

    checkCurrentSection();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };


  const buttonClasses = isDarkSection 
    ? "fixed bottom-6 right-6 z-50 p-3 bg-accent-ink text-surface-inverse rounded-full shadow-lg hover:bg-accent-ink/90 transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-accent-ink/50"
    : "fixed bottom-6 right-6 z-50 p-3 bg-ink text-surface rounded-full shadow-lg hover:bg-ink/90 transition-all duration-300 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-ink-faint/50";

  const iconColor = "currentColor";

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className={buttonClasses}
          aria-label="Scroll to top"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke={iconColor}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 10l7-7m0 0l7 7m-7-7v18"
            />
          </svg>
        </button>
      )}
    </>
  );
};

export default ScrollToTop;